import axios from "axios";
import i18next from 'i18next';
import BACKEND_URL from "../config";

const transport = axios.create({
    baseURL: BACKEND_URL,
    timeout: 180000, // 3 دقائق للطلبات الكبيرة (رفع الصور)
});

// Cache للقيم المستخدمة بكثرة لتحسين الأداء
let cachedValues = {
    token: null,
    storeId: null,
    countryId: null,
    language: null
};

// تحديث الـ cache عند الحاجة
const updateCache = () => {
    cachedValues.token = localStorage.getItem('accessToken');
    cachedValues.storeId = localStorage.getItem('store-id');
    cachedValues.countryId = localStorage.getItem('country-id');
    cachedValues.language = localStorage.getItem('i18nextLng') || 'ar';
};

// تحديث الـ cache عند التحميل الأول
updateCache();

transport.interceptors.request.use((config) => {
    // استخدام القيم المخزنة مؤقتاً
    const currentLanguageCode = cachedValues.language || localStorage.getItem('i18nextLng') || 'ar';

    config.headers['lang'] = currentLanguageCode;
    config.headers['accept-language'] = currentLanguageCode;

    const token = localStorage.getItem('accessToken') || cachedValues.token;
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }

    // A caller may target one store (new-store setup) without waiting on localStorage.
    const explicitStoreId = config.headers?.get?.('store-id') || config.headers?.['store-id'];
    // Prefer live localStorage so account switches aren't stuck on stale cached headers
    const storeId = explicitStoreId || localStorage.getItem('store-id') || cachedValues.storeId;
    const countryId = localStorage.getItem('country-id') || cachedValues.countryId;

    if (storeId && storeId !== 'undefined') {
        config.headers['store-id'] = storeId;
    }
    if (countryId && countryId !== null && countryId !== 'undefined') {
        config.headers['country-id'] = countryId;
    }

    return config;
}, (error) => {
    return Promise.reject(error);
});

transport.interceptors.response.use(
    (response) => response,
    (error) => {

        // التعامل مع timeout errors
        if (error.code === 'ECONNABORTED') {
            console.error('Request timeout - please check your connection');
        }

        if (error.response && error.response.status === 401) {
            console.error("Unauthorized! Redirecting to login...");
            // Dynamic import avoids circular init with clearAccountSession → axios
            import('./clearAccountSession')
                .then(({ clearAccountSession }) => {
                    clearAccountSession({ clearAuth: true });
                })
                .catch(() => {
                    localStorage.removeItem('accessToken');
                    localStorage.removeItem('user');
                    localStorage.removeItem('store-id');
                    localStorage.removeItem('country-id');
                    cachedValues.token = null;
                    cachedValues.storeId = null;
                    cachedValues.countryId = null;
                })
                .finally(() => {
                    window.location.href = "/login";
                });
            return Promise.reject(error);
        }
        return Promise.reject(error);
    }
);

i18next.on('languageChanged', (lng) => {
    localStorage.setItem('i18nextLng', lng);
    cachedValues.language = lng; // تحديث الـ cache
    transport.defaults.headers['lang'] = lng;
    transport.defaults.headers['accept-language'] = lng;
});

// دالة helper لتحديث الـ cache يدوياً عند الحاجة
export const refreshAxiosCache = () => {
    updateCache();
};

export default transport;
